import {Component} from 'react';
import "./ForParents/forParents.css";
import "../../css/styles.css";
import DisplayLessonListModal from './display_lesson_list_modal';

class LearningOverview extends Component {
    constructor(props) { 
        super(props);
        this.state = {
            userName: "",
            modalOpen: true,
            openTeacherMaterialModal: false,
        }
    }
     
    openPDFDocuments(){
        this.setState({openTeacherMaterialModal: true});
    }
  
    closeLessonListModal(){
        this.setState({openTeacherMaterialModal: false});
    }
      
    render() {
      
        this.headerClass = "for-parent-text-size font-weight-bold mt-3 mx-4";
        this.textClass = "for-parent-text-size mx-4";
                   
    return <>
        <div className="col-8">
        <div className="card mt-3 rounded-corners-lg height-max">
            <button className="pages-back-button ml-4 mt-4" 
                        onClick ={()=> this.props.goBack()}>
                                Back
            </button>
            <h3 className="mt-0 p-0 text-center">For Parents and Teachers</h3>
            <h5 className="text-center">Learning Overview</h5>
                            
            <div className="overflow-scroll mr-3 ml-3 mb-3">
                <div className={this.textClass}>     
                  Welcome! MoneyTrain is designed to make learning about money both fun and 
                  practical. The game is fully aligned with Colorado State Financial Literacy 
                  Standards, and the accompanying lesson plans give students hands-on experience 
                  with real-world financial skills. This page provides a quick overview of the key 
                  concepts students will explore and the skills they’ll practice while playing the game.
                </div>
                <h6 className={this.headerClass}>Core Financial Literacy Topics</h6>  
                <div className={this.textClass}>  
                  Students will develop skills in:
                  <ul className="bulleted-list">
                    <li><b>Budgeting & Money Management</b> – Planning spending, tracking income 
                      and expenses, and prioritizing needs versus wants.</li>
                    <li><b>Banking Basics</b> – Understanding checking and savings accounts, deposits, 
                      withdrawals, and online banking.</li>
                    <li><b>Credit & Debt</b> – Using credit responsibly, understanding loans and interest.
                      </li>
                    <li><b>Saving & Investing</b> – Managing regular bank accounts, high-yield savings, 
                      CDs, and 401(k) accounts (conservative, balanced, and aggressive). Students also 
                      explore investing in stocks, mutual funds, index funds, and bonds, experimenting 
                      with multiple options to see how different strategies play out over time.</li>
                    <li><b>Income & Employment</b> – Understanding paychecks, taxes, side hustles, and 
                      real-life earning scenarios.</li>
                    <li><b>Financial Decision-Making</b> – Evaluating options, managing trade-offs, and 
                      seeing the consequences of choices in a safe environment.</li>
                    <li><b>Risk & Protection</b> – Planning for emergencies, learning about insurance, and 
                        practicing safe online financial habits.</li>
                  </ul>
                
                </div>
                <h6 className={this.headerClass}>How the Game Reinforces Learning:</h6>  
                <div className={this.textClass}>  
                  MoneyTrain turns financial decisions into engaging gameplay. Students make choices 
                  about spending, saving, investing, and earning, and see how those choices affect their 
                  virtual financial future. The game uses badges, achievements, and real-time feedback 
                  to make learning interactive and rewarding.
                  Examples include:
                </div>
                <ul className="bulleted-list ml-4">
                      <li>Choosing how much to save or spend and tracking the results over time.</li>
                      <li>Comparing loans or investment options to make informed decisions.</li>
                      <li>Managing a budget across multiple categories like bills, entertainment, 
                        and side hustles.</li>
                      <li>Experimenting with different investment types and strategies to see their 
                        long-term effects.</li>
                </ul>
                <h6 className={this.headerClass}>Quick Tips for Parents & Teachers</h6> 
                 <ul className="bulleted-list ml-4">
                      <li>Encourage discussion after gameplay: “What would you do differently in real life?".</li>
                      <li>Connect game experiences to real-world decisions, such as budgeting an allowance 
                        or saving for a trip.</li>
                      <li>Review Player Reports to track progress and highlight achievements.</li>
                      <li>Remind students that mistakes in the game are part of learning — it’s safe 
                        to experiment!</li>
                </ul>
                <h6 className={this.headerClass}>Learn More:</h6>  
                <div className={this.textClass}>  
                 For a deeper dive, the 12 MoneyTrain lessons include lesson plans, facilitator guides, 
                 and student worksheets to reinforce concepts and extend learning beyond the game.  Just
                 click on the "Instructional Materials" to view, print and/or download the lesson PDF docs.
                 <div className="mt-2 text-center">
                  <strong><em> Your students will have fun while developing essential money skills that 
                    prepare them for the real world!
                  </em></strong>
                </div>

                </div>
          
            </div>
           
            <div className="text-center w-80 mb-4 pt-0">
                <button className="btn-group-small reduce-white-space mb-2 
                  cursor-is-pointer" 
                        onClick ={()=> this.openPDFDocuments("gameProfile")}>
                                Instructional Materials
                </button>
            </div>
           
        </div>    
              
                {this.state.openTeacherMaterialModal  ?
                        <DisplayLessonListModal
                            show={this.state.openTeacherMaterialModal}
                            onClose={()=> this.closeLessonListModal()}/>
                :
                    null
                }
       </div>
    </>
    }

}

export default LearningOverview;